<template>
  <v-container fluid class="my-5">
    <MesaDirectivaIntegrantes />
  </v-container>
</template>

<script>
import MesaDirectivaIntegrantes from '@/components/mesaDirectiva/MesaDirectivaIntegrantes.vue'

export default {
  name: 'mesa_directiva_integrantes',
  components: {
    MesaDirectivaIntegrantes
  }
}
</script>
